// Modulo with negative number support
export default (n: number, m: number) => ((n % m) + m) % m;
